import React, { Fragment } from "react"

const Skills = () => {
  return (
    <Fragment>
      <h3 className="fade-in">What are my technical skills?</h3>
      <ul className="fade-in">
        <li>
          <strong>Markup:</strong> HTML, Handlebars, Mustache, Pug, doT.JS
        </li>
        <li>
          <strong>Client-Side Logic:</strong> JavaScript, jQuery, Knockout,
          React, Vue, Webpack
        </li>
        <li>
          <strong>Styling:</strong> CSS, Sass, Less
        </li>
        <li>
          <strong>Version Control:</strong> Git, Team Foundation Server, Azure
          DevOps
        </li>
        <li>
          <strong>Content Management:</strong> Sitecore, SharePoint
        </li>
        <li>
          <strong>Package Manager:</strong> NPM
        </li>
        <li>
          <strong>IDE:</strong> Visual Studio
        </li>
        <li>
          <strong>Task Runners:</strong> Grunt, Gulp
        </li>
        <li>
          <strong>Testing:</strong> Jest
        </li>
        <li>
          <strong>Frameworks:</strong> Bootstrap, Reactstrap
        </li>
        <li>
          <strong>Debugging:</strong> Fiddler, browser dev tools
        </li>
        <li>
          <strong>Design:</strong> Photoshop, Illustrator, InDesign
        </li>
        <li>
          <strong>Documentation and Tracking:</strong> Jira, Confluence, Azure
          DevOps
        </li>
        <li>
          <strong>Accessibility:</strong> Siteimprove
        </li>
      </ul>
    </Fragment>
  )
}

export default Skills
